import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes as Switch,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { isAdminUser, isAggregatorUser } from "utils/helper";
import history from "utils/history";
import { ROUTES } from "./routePaths";
import { permissions } from "utils/permissions";
import AuthenticatedRoute from "./AuthenticatedRoute";
import Register from "pages/authPages/Register";
import Login from "pages/authPages/Login";
import OTPPage from "pages/authPages/OTPPage";
import PasswordSet from "pages/authPages/PasswordSet";
import PasswordChange from "pages/authPages/PasswordChange";
import PasswordForgot from "pages/authPages/PasswordForgot";
import PasswordSetSuccess from "pages/authPages/PasswordSetSuccess";
import TermsAndConditions from "pages/authPages/TermsAndConditions";
import Dashboard from "pages/dashboards";
import AggregatorOnboardingStats from "pages/dashboards/AggregatorDashboard/OnboardingStatistics";
import AdminOnboardingStats from "pages/dashboards/AdminDashboard/OnboardingStatistics";
import AdminTerminalStats from "pages/dashboards/AdminDashboard/TerminalTransactions";
import AggregatorTerminalStats from "pages/dashboards/AggregatorDashboard/TerminalTransactions";
import AgentTerminalStats from "pages/dashboards/AgentDashboard/TerminalTransactions";
import CreateAgent from "pages/agggregatorAndAdmin/createAgent";
import AdminAgentManagement from "pages/admin/users/UserManagement/Agents";
import AdminAdminManagement from "pages/admin/users/UserManagement/Admins";
import ProfilePage from "pages/ProfilePage";
import UserProfile from "pages/admin/users/UserManagement/UserProfile/index";
import CreateAdminUser from "pages/admin/users/CreateAdminUser";
import RegisterTerminal from "pages/admin/Terminals/RegisterTerminal/";
import TerminalRequests from "pages/admin/Terminals/TerminalRequests/";
import ManageTerminals from "pages/admin/Terminals/ManageTerminals/";
import CreateRole from "pages/admin/Roles/CreateRole/";
import ManageRoles from "pages/admin/Roles/ManageRoles/";
import ManageNotifications from "pages/admin/ManageNotifications";
import Terminals from "pages/agentAndAggregator/Terminals";
import PMAccounts from "pages/agentAndAggregator/PMAccounts";
import RequestTerminal from "pages/agentAndAggregator/Terminals/RequestTerminal";
import SwapTerminal from "pages/agentAndAggregator/Terminals/SwapTerminal";
import Onboarding from "pages/agentAndAggregator/Onboarding";
import PendingApproval from "pages/agentAndAggregator/Onboarding/PendingApproval";
import StatusInfo from "pages/agentAndAggregator/Onboarding/StatusInfo";
import GuarantorForm from "pages/agentAndAggregator/Onboarding/OnboardingForm/GuarantorForm";
import PendingKYC from "pages/admin/Approvals/PendingKYC";
import PendingKYCs from "pages/admin/Approvals/PendingKYCs";
import ValidatedKYCs from "pages/admin/Approvals/ValidatedKYCs";
import ValidatedKYC from "pages/admin/Approvals/ValidatedKYC";
import UserAccounts from "pages/admin/Approvals/UserAccounts";
import TerminalsAuthorization from "pages/admin/Approvals/TerminalsAuthorization";
import PasswordSetting from "pages/settings/PasswordSetting";
import TerminalsMappingApproval from "pages/admin/Approvals/TerminalsMappingApproval";
import RolesAuthorization from "pages/admin/Approvals/RolesAuthorization";
import AgentManagement from "pages/aggregator/AgentManagement/";
import Transactions from "pages/Transactions";
import Reports from "pages/Reports";
import NotFound from "pages/NotFound";
import PocketMoniAccounts from "pages/admin/Approvals/PMAccountsAdded/PMFirstLevelApproval";
import PmFinalApproval from "pages/admin/Approvals/PMAccountsAdded/PMSecondLevelApproval";
import RequestNIN from "pages/authPages/RequestNIN";
import GuestRequestNIN from "pages/authPages/GuestRequestNin";
import GuestRequestNINSucess from "pages/authPages/GuestRequestNinSuccess";

const AppRoutes = () => {
  const { user } = useSelector((state) => state.user);

  const {
    login,
    register,
    termsAndCondition,
    dashboard,
    dashboardOnboardingStats,
    dashboardTerminalStats,
    agentOnboarding,
    agentOnboardingStart,
    agentOnboardingPending,
    agentManagement,
    manageAgents,
    passwordSet,
    passwordForgot,
    passwordSetSuccess,
    passwordChange,
    otpPage,
    createAgent,
    registerTerminal,
    manageUsers,
    viewUser,
    userProfile,
    userGuarantorInfo,
    createAdminUser,
    terminals,
    requestTerminal,
    swapTerminal,
    terminalRequests,
    manageTerminals,
    createRole,
    manageRoles,
    manageNotifications,
    pendingKYC,
    pendingKYCs,
    validatedKYCs,
    validatedKYC,
    adminAccounts,
    terminalsAuthorization,
    terminalsMappingApproval,
    rolesAuthorization,
    passwordSetting,
    notFound,
    transactions,
    reports,
    viewPmAccounts,
    pmAccountsApproval,
    finalApproval,
    requestNin,
    guestRequestNin,
    guestRequestNinSuccess,
  } = ROUTES;

  const {
    canSeeAgentManagement,
    canAddAgentAccount,
    canSeeTerminals,
    canSeeManageTerminals,
    canSeeRegisterTerminals,
    canRequestForTerminals,
    canSeeTerminalRequests,
    canSeeUserManagementAdmin,
    canSeeUserManagement,
    // canSeeAdminUserManagement,
    canSeeApproveAgentAccount,
    canSeeApproveAgent,
    canSeeApproveTerminalAuthorization,
    canSeeApproveTerminalMapping,
    // canSeeApproveAdminAccount,
    canSeeApproveRoleAuthorization,
    canCreateRole,
    canSeeRoleManagemnt,
    canSeeNotificationManagement,
    canSeeOnboardingStaistics,
    canSeeTransactionReport,
    canSeeApprovePmAccountLevelOne,
    canSeeApprovePmAccountLevelTwo,
  } = permissions;

  const routes = [
    {
      link: login,
      exact: true,
      component: <Login />,
      requiresAuth: false,
    },
    {
      link: register,
      exact: true,
      component: <Register />,
      requiresAuth: false,
    },
    {
      link: otpPage,
      exact: true,
      component: <OTPPage />,
      requiresAuth: false,
    },
    {
      link: passwordSet,
      exact: true,
      component: <PasswordSet />,
      requiresAuth: false,
    },
    {
      link: passwordChange,
      exact: true,
      component: <PasswordChange />,
      requiresAuth: false,
    },
    {
      link: passwordForgot,
      exact: true,
      component: <PasswordForgot />,
      requiresAuth: false,
    },
    {
      link: passwordSetSuccess,
      exact: true,
      component: <PasswordSetSuccess />,
      requiresAuth: false,
    },
    {
      link: guestRequestNin,
      exact: true,
      component: <GuestRequestNIN />,
      requiresAuth: false,
    },
    {
      link: guestRequestNinSuccess,
      exact: true,
      component: <GuestRequestNINSucess />,
      requiresAuth: false,
    },
    {
      link: passwordSetting,
      exact: true,
      component: <PasswordSetting />,
      requiresAuth: true,
    },
    {
      link: requestNin,
      exact: true,
      component: <RequestNIN />,
    },
    {
      link: termsAndCondition,
      exact: true,
      component: <TermsAndConditions />,
      requiresAuth: false,
    },
    {
      link: dashboard,
      exact: true,
      component: <Dashboard />,
      requiresAuth: true,
    },
    {
      link: dashboardOnboardingStats,
      exact: true,
      component: isAdminUser(user) ? (
        <AdminOnboardingStats />
      ) : (
        <AggregatorOnboardingStats />
      ),
      requiresAuth: true,
      canAccess: canSeeOnboardingStaistics,
    },
    {
      link: dashboardTerminalStats,
      exact: true,
      component: isAdminUser(user) ? (
        <AdminTerminalStats />
      ) : isAggregatorUser(user) ? (
        <AggregatorTerminalStats />
      ) : (
        <AgentTerminalStats />
      ),
      requiresAuth: true,
      // canAccess:
    },
    {
      link: agentOnboardingStart,
      exact: true,
      component: <StatusInfo />,
      requiresAuth: true,
      // canAccess: canCreateAgentPersonalDetails
    },
    {
      link: agentOnboarding,
      exact: true,
      component: <Onboarding />,
      requiresAuth: true,
      // canAccess: canCreateAgentPersonalDetails
    },
    {
      link: agentOnboardingPending,
      exact: true,
      component: <PendingApproval />,
      requiresAuth: true,
      // canAccess: canCreateAgentPersonalDetails
    },
    {
      link: agentManagement,
      exact: true,
      component: <AgentManagement />,
      requiresAuth: true,
      canAccess: canSeeAgentManagement,
    },
    {
      link: createAgent,
      exact: true,
      component: <CreateAgent />,
      requiresAuth: true,
      canAccess: canAddAgentAccount,
    },
    {
      link: terminals,
      exact: true,
      component: <Terminals />,
      requiresAuth: true,
      fullWidth: true,
      canAccess: canSeeTerminals,
    },
    {
      link: manageTerminals,
      exact: true,
      component: <ManageTerminals />,
      requiresAuth: true,
      fullWidth: true,
      canAccess: canSeeManageTerminals,
    },
    {
      link: registerTerminal,
      exact: true,
      component: <RegisterTerminal />,
      requiresAuth: true,
      fullWidth: true,
      canAccess: canSeeRegisterTerminals,
    },
    {
      link: requestTerminal,
      exact: true,
      component: <RequestTerminal />,
      requiresAuth: true,
      fullWidth: true,
      canAccess: canRequestForTerminals,
    },
    {
      link: swapTerminal,
      exact: true,
      component: <SwapTerminal />,
      requiresAuth: true,
      fullWidth: true,
      canAccess: canRequestForTerminals,
    },
    {
      link: terminalRequests,
      exact: true,
      component: <TerminalRequests />,
      requiresAuth: true,
      fullWidth: true,
      canAccess: canSeeTerminalRequests,
    },
    {
      link: createAdminUser,
      exact: true,
      component: <CreateAdminUser />,
      requiresAuth: true,
      //Ask what permission to guide this
      // canAccess: "" ///////////////////////////////////////////
    },
    {
      link: userProfile,
      exact: true,
      component: <ProfilePage />,
      requiresAuth: true,
    },
    {
      link: userGuarantorInfo,
      exact: true,
      component: <GuarantorForm />,
      requiresAuth: true,
    },
    {
      link: manageUsers,
      exact: true,
      component: <AdminAdminManagement />,
      requiresAuth: true,
      canAccess: canSeeUserManagementAdmin,
    },
    {
      link: manageAgents,
      exact: true,
      component: <AdminAgentManagement />,
      requiresAuth: true,
      canAccess: canSeeUserManagement,
    },

    {
      link: viewUser,
      exact: true,
      component: <UserProfile />,
      requiresAuth: true,
      // canAccess: canQueryUser
    },
    {
      link: pendingKYC, // viewIndividial
      exact: true,
      component: <PendingKYC />,
      requiresAuth: true,
      canAccess: canSeeApproveAgentAccount,
    },
    {
      link: pendingKYCs, // viewall
      exact: true,
      component: <PendingKYCs />,
      requiresAuth: true,
      canAccess: canSeeApproveAgentAccount,
    },
    {
      link: validatedKYCs, // viewall
      exact: true,
      component: <ValidatedKYCs />,
      requiresAuth: true,
      canAccess: canSeeApproveAgent,
    },
    {
      link: validatedKYC, // viewall
      exact: true,
      component: <ValidatedKYC />,
      requiresAuth: true,
      canAccess: canSeeApproveAgent,
    },
    {
      link: adminAccounts,
      exact: true,
      component: <UserAccounts />,
      requiresAuth: true,
      // canAccess: canSeeUserManagementAdmin,
    },
    {
      link: pmAccountsApproval, // viewall
      exact: true,
      component: <PocketMoniAccounts />,
      requiresAuth: true,
      canAccess: canSeeApprovePmAccountLevelOne,
    },
    {
      link: finalApproval, // viewall
      exact: true,
      component: <PmFinalApproval />,
      requiresAuth: true,
      canAccess: canSeeApprovePmAccountLevelTwo,
    },
    {
      link: terminalsAuthorization,
      exact: true,
      component: <TerminalsAuthorization />,
      requiresAuth: true,
      canAccess: canSeeApproveTerminalAuthorization,
    },
    {
      link: terminalsMappingApproval,
      exact: true,
      component: <TerminalsMappingApproval />,
      requiresAuth: true,
      canAccess: canSeeApproveTerminalMapping,
    },
    {
      link: rolesAuthorization,
      exact: true,
      component: <RolesAuthorization />,
      requiresAuth: true,
      canAccess: canSeeApproveRoleAuthorization,
    },
    {
      link: createRole,
      exact: true,
      component: <CreateRole />,
      requiresAuth: true,
      canAccess: canCreateRole,
    },
    {
      link: manageRoles,
      exact: true,
      component: <ManageRoles />,
      requiresAuth: true,
      canAccess: canSeeRoleManagemnt,
    },
    {
      link: manageNotifications,
      exact: true,
      component: <ManageNotifications />,
      requiresAuth: true,
      canAccess: canSeeNotificationManagement,
    },
    {
      link: transactions,
      exact: true,
      component: <Transactions />,
      requiresAuth: true,
      canAccess: canSeeTransactionReport,
    },
    {
      link: reports,
      exact: true,
      component: <Reports />,
      requiresAuth: true,
      fullWidth: true,
    },
    {
      link: viewPmAccounts,
      exact: true,
      component: <PMAccounts />,
      requiresAuth: true,
      fullWidth: true,
    },
    {
      link: notFound,
      exact: true,
      component: <NotFound />,
    },
    {
      link: "*",
      exact: true,
      component: <NotFound />,
    },
  ];

  return (
    <Router history={history}>
      <Switch>
        {routes.map(
          (
            { link, exact, component, requiresAuth, canAccess, fullWidth },
            key
          ) => {
            if (!requiresAuth) {
              return (
                <Route
                  path={link}
                  exact={exact}
                  element={component}
                  key={key}
                />
              );
            } else {
              return (
                <Route
                  path={`${link}`}
                  exact={exact}
                  element={
                    <AuthenticatedRoute
                      canAccess={canAccess}
                      fullWidth={fullWidth}
                    >
                      {component}
                    </AuthenticatedRoute>
                  }
                  key={key}
                />
              );
            }
          }
        )}
      </Switch>
    </Router>
  );
};

export default AppRoutes;
